import React from "react";
import { I18n } from "./LangUtil";

const TypicalPopup = ({ data = {} }) => {
    const { onClickYes = () => {}, onClickNo = () => {} } = data.events || {};

    return (
        <div className="typical-popup">
            <h5 style={{ textAlign: "center" }}>
                <strong>{I18n("g.lbl.info")}</strong>
            </h5>
            <p style={{ textAlign: "center", whiteSpace: "pre-wrap" }}>{data.text}</p>
            {!data.noButtons ? (
                <div style={{ margin: "0 auto", width: 175, textAlign: "center" }}>
                    <div>
                        <button className="btn btn-success" onClick={onClickNo}>
                            {data.noBtnText ? data.noBtnText : "No"}
                        </button>
                        <button className="btn btn-success marginr10" onClick={onClickYes}>
                            {data.yesBtnText ? data.yesBtnText : I18n("g.lbl.yes")}
                        </button>
                    </div>
                </div>
            ) : (
                <div style={{ margin: "0 auto", width: 50 }}>
                    <button className="btn btn-success" onClick={onClickNo}>
                        Ok
                    </button>
                </div>
            )}
        </div>
    );
};

export default TypicalPopup;
